import { BASE_URL } from '../apiConfig';
import { authFetch, handleAuthResponse } from '../../utils/authFetch';

export const addCommercialContractAPI = async (payload) => {
  // Example of making an authenticated request using fetch
  const authToken = localStorage.getItem("authToken");

  let options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
      apikey: "abc123",
    },
    body: JSON.stringify(payload), // Use the payload without the property_img
  };

  return await authFetch(
    `${BASE_URL}/addCommercialContract`, 
    // "https://gzisg4fzzpgklhicwsp5vppnum0gbxei.lambda-url.ap-southeast-1.on.aws/addcommercialcontract",
    options
  ).then(handleAuthResponse);
};

export const createCommercialContractAPI = async (payload) => {
  let options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "abc123",
      apikey: "abc123",
    },
    body: JSON.stringify(payload),
  };
  return await authFetch(
    "https://gzisg4fzzpgklhicwsp5vppnum0gbxei.lambda-url.ap-southeast-1.on.aws/createcommercial",
    options
  ).then(handleAuthResponse);

};

export const allSubjectsLiftedAPI = async (payload) => {

  let options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer`,
      apikey: "abc123",
    },
    body: JSON.stringify(payload), // Use the payload without the property_img
  };
  
  return await authFetch(
    "https://gzisg4fzzpgklhicwsp5vppnum0gbxei.lambda-url.ap-southeast-1.on.aws/allsubjectslifted",
    options
  ).then(handleAuthResponse);
};

export const createContractAPI = async (payload) => {
  let options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "abc123",
      apikey: "abc123",
    },
    body: JSON.stringify(payload),
  };
  return await authFetch(
    "https://gzisg4fzzpgklhicwsp5vppnum0gbxei.lambda-url.ap-southeast-1.on.aws/initcontract",
    options
  ).then(handleAuthResponse);
};

export const sellerSignAPI = async (payload) => {
  const authToken = localStorage.getItem("authToken");
  let options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
      apikey: "abc123",
    },
    body: JSON.stringify(payload),
  };
  return await authFetch(
    "https://gzisg4fzzpgklhicwsp5vppnum0gbxei.lambda-url.ap-southeast-1.on.aws/sellersign",
    options
  ).then(handleAuthResponse);
};

export const buyerSignAPI = async (payload) => {
  const authToken = localStorage.getItem("authToken");
  let options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
      apikey: "abc123",
    },
    body: JSON.stringify(payload),
  };
  return await authFetch(
    "https://gzisg4fzzpgklhicwsp5vppnum0gbxei.lambda-url.ap-southeast-1.on.aws/buyersign",
    options
  ).then(handleAuthResponse);
};

export const updateCommercialAPI = async (payload) => {
  let options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "abc123",
      apikey: "abc123",
    },
    body: JSON.stringify(payload),
  };
  return await authFetch(
    "https://gzisg4fzzpgklhicwsp5vppnum0gbxei.lambda-url.ap-southeast-1.on.aws/updatecommercial",
    options
  ).then(handleAuthResponse);
};

export const confirmBySellerAPI = async (payload) => {
  // Example of making an authenticated request using fetch
  const authToken = localStorage.getItem("authToken");

  let options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
      apikey: "abc123",
    },
    body: JSON.stringify(payload), // Use the payload without the property_img
  };
  return await authFetch(
    `${BASE_URL}/sellerSign`, 
    // "https://gzisg4fzzpgklhicwsp5vppnum0gbxei.lambda-url.ap-southeast-1.on.aws/confirmbyseller",
    options
  ).then(handleAuthResponse);
};

export const confirmByBuyerAPI = async (payload) => {
  // Example of making an authenticated request using fetch
  const authToken = localStorage.getItem("authToken");

  let options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
      apikey: "abc123",
    },
    body: JSON.stringify(payload), // Use the payload without the property_img
  };
  return await authFetch(
    `${BASE_URL}/buyerSign`, 
    // "https://gzisg4fzzpgklhicwsp5vppnum0gbxei.lambda-url.ap-southeast-1.on.aws/confirmbybuyer",
    options
  ).then(handleAuthResponse);
};

export const contractsListByUserAPI = async (payload) => {
  let options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "abc123",
      apikey: "abc123",
    },
    body: JSON.stringify(payload),
  };
  return await authFetch(
    `${BASE_URL}/getCommercialContractList`, 
    // "https://gzisg4fzzpgklhicwsp5vppnum0gbxei.lambda-url.ap-southeast-1.on.aws/getcontractlist",
    options
  ).then(handleAuthResponse);
};

export const updateCommercialDBAPI = async (payload) => {
  let options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "abc123",
      apikey: "abc123",
    },
    body: JSON.stringify(payload),
  };
  return await authFetch(
    `${BASE_URL}/updateCommercialDb`, 
    // "https://gzisg4fzzpgklhicwsp5vppnum0gbxei.lambda-url.ap-southeast-1.on.aws/updatecommercialdb",
    options
  ).then(handleAuthResponse);
};

export const updateCommercialDB2API = async (payload) => {
  // Example of making an authenticated request using fetch
  const authToken = localStorage.getItem("authToken");

  let options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
      apikey: "abc123",
    },
    body: JSON.stringify(payload), // Use the payload without the property_img
  };
  
  return await authFetch(
    `${BASE_URL}/liftAllSubject`,
    // "https://gzisg4fzzpgklhicwsp5vppnum0gbxei.lambda-url.ap-southeast-1.on.aws/updatecommercialdb2",
    options
  ).then(handleAuthResponse);
};

export const updateCommercialDB3API = async (payload) => {
  let options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "abc123",
      apikey: "abc123",
    },
    body: JSON.stringify(payload),
  };
  return await authFetch(
    `${BASE_URL}/updateWithInterestedBuyer`, 
    // "https://gzisg4fzzpgklhicwsp5vppnum0gbxei.lambda-url.ap-southeast-1.on.aws/updatecommercialdb",
    options
  ).then(handleAuthResponse);
};

export const updateProductDBAPI = async (payload) => {
  let options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "abc123",
      apikey: "abc123",
    },
    body: JSON.stringify(payload),
  };
  return await authFetch(
    `${BASE_URL}/updateLotState`, 
    // "https://gzisg4fzzpgklhicwsp5vppnum0gbxei.lambda-url.ap-southeast-1.on.aws/updateproductdb",
    options
  ).then(handleAuthResponse);
};

export const transferProductApi = async (payload) => {
  // Example of making an authenticated request using fetch
  const authToken = localStorage.getItem("authToken");

  let options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
      apikey: "abc123",
    },
    body: JSON.stringify(payload), // Use the payload without the property_img
  };
  return await authFetch(
    `${BASE_URL}/transformLot`, 
    // "https://gzisg4fzzpgklhicwsp5vppnum0gbxei.lambda-url.ap-southeast-1.on.aws/transformproduct",
    options
  ).then(handleAuthResponse);
};

export const transportProductApi = async (payload) => {
  // Example of making an authenticated request using fetch
  const authToken = localStorage.getItem("authToken");

  let options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
      apikey: "abc123",
    },
    body: JSON.stringify(payload), // Use the payload without the property_img
  };
  return await authFetch(
    `${BASE_URL}/transportLot`, 
    // "https://gzisg4fzzpgklhicwsp5vppnum0gbxei.lambda-url.ap-southeast-1.on.aws/transportproduct",
    options
  ).then(handleAuthResponse);
};

export const getProductsListAPI = async (language) => {
  let options = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "abc123",
      apikey: "abc123",
    },
  };
  return await authFetch(
    `${BASE_URL}/getMasterProductName?language=${language}`, 
    // "https://gzisg4fzzpgklhicwsp5vppnum0gbxei.lambda-url.ap-southeast-1.on.aws/getmasterproductnames",
    options
  ).then(handleAuthResponse);
};

export const getProductStateAPI = async (language) => {
  let options = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "abc123",
      apikey: "abc123",
    },
  };
  return await authFetch(
    `${BASE_URL}/getProductState?language=${language}`, 
    // "https://gzisg4fzzpgklhicwsp5vppnum0gbxei.lambda-url.ap-southeast-1.on.aws/getproductstates",
    options
  ).then(handleAuthResponse);
};

export const getLocationsListAPI = async (language) => {
  let options = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "abc123",
      apikey: "abc123",
    },
  };
  return await authFetch(
    `${BASE_URL}/getLocation?language=${language}`, 
    // "https://gzisg4fzzpgklhicwsp5vppnum0gbxei.lambda-url.ap-southeast-1.on.aws/getlocation",
    options
  ).then(handleAuthResponse);
};

export const getFetchLedgerLotAPI = async (payload) => {
  let options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "abc123",
      apikey: "abc123",
    },
    body: JSON.stringify(payload),
  };
  return await authFetch(
    `${BASE_URL}/fetchLedgerLot`, 
    // "https://gzisg4fzzpgklhicwsp5vppnum0gbxei.lambda-url.ap-southeast-1.on.aws/getlocation",
    options
  ).then(handleAuthResponse);
};

export const getFetchLedgerLotHistoryAPI = async (payload) => {
  let options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "abc123",
      apikey: "abc123",
    },
    body: JSON.stringify(payload),
  };
  return await authFetch(
    `${BASE_URL}/fetchLedgerLotHistory`, 
    // "https://gzisg4fzzpgklhicwsp5vppnum0gbxei.lambda-url.ap-southeast-1.on.aws/getlocation",
    options
  ).then(handleAuthResponse);
};

export const getUOMListAPI = async (language) => {
  let options = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "abc123",
      apikey: "abc123",
    },
  };
  return await authFetch(
    `${BASE_URL}/getUOMList?language=${language}`, 
    options
  ).then(handleAuthResponse);
};

export const getProductLotListAPI = async (payload) => {
  const {targetLanguage, userId} = payload;

  let params = new URLSearchParams({
    language: targetLanguage || 'en',
    userId: userId
  }).toString();

  let options = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "abc123",
      apikey: "abc123",
    },
  };
  return await authFetch(
    `${BASE_URL}/getProductLotList?${params}`, 
    options
  ).then(handleAuthResponse);
};

export const getProductNextStateAPI = async (language) => {
  let options = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "abc123",
      apikey: "abc123",
    },
  };
  return await authFetch(
    `${BASE_URL}/getProductNextState?`, 
    // "https://gzisg4fzzpgklhicwsp5vppnum0gbxei.lambda-url.ap-southeast-1.on.aws/getproductstates",
    options
  ).then(handleAuthResponse);
};

export const getProductNameDescriptionAPI = async (language) => {
  let options = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "abc123",
      apikey: "abc123",
    },
  };
  return await authFetch(
    `${BASE_URL}/getProductNameDescription?language=${language}`, 
    options
  ).then(handleAuthResponse);
};

export const archiveLotAPI = async (payload) => {
  // Example of making an authenticated request using fetch
  const authToken = localStorage.getItem("authToken");

  let options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
      apikey: "abc123",
    },
    body: JSON.stringify(payload), // Use the payload without the property_img
  };
  return await authFetch(
    `${BASE_URL}/archiveLot`, 
    options
  ).then(handleAuthResponse);
};

export const unarchiveLotAPI = async (payload) => {
  // Example of making an authenticated request using fetch
  const authToken = localStorage.getItem("authToken");

  let options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
      apikey: "abc123",
    },
    body: JSON.stringify(payload), // Use the payload without the property_img
  };
  return await authFetch(
    `${BASE_URL}/unarchiveLot`, 
    options
  ).then(handleAuthResponse);
};

export const updateLotFieldsAPI = async (payload) => {
  const authToken = localStorage.getItem("authToken");

  let options = {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
      apikey: "abc123",
    },
    body: JSON.stringify(payload),
  };
  return await authFetch(
    `${BASE_URL}/updateLotFields`,
    options
  ).then(handleAuthResponse);
};